import React from "react";
import { Link } from "react-router-dom";
import Logo from "./Logo";
import { WhatsappLogo, EnvelopeSimple, Phone, MapPin } from "@phosphor-icons/react";

export const Footer = () => (
  <footer className="bg-primary text-foreground pt-20 pb-8" data-testid="main-footer">
    <div className="max-w-[1400px] mx-auto px-6 md:px-12">
      <div className="grid md:grid-cols-3 gap-12 pb-16 border-b border-foreground/15">
        <div>
          <Logo />
          <p className="mt-5 text-sm text-foreground/70 max-w-xs leading-relaxed">
            A boutique atelier crafting durable, comfortable and precisely tailored school uniforms for institutions across Pune.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-foreground/60 mb-5">Navigate</p>
          <div className="flex flex-col gap-3 text-sm">
            <Link to="/" className="hover:text-accent transition-colors">Home</Link>
            <Link to="/shop" className="hover:text-accent transition-colors">Shop Uniforms</Link>
            <a href="/#schools" className="hover:text-accent transition-colors">Our Schools</a>
            <a href="/#about" className="hover:text-accent transition-colors">The Atelier</a>
            <Link to="/admin/login" className="hover:text-accent transition-colors" data-testid="footer-admin-link">Admin</Link>
          </div>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] text-foreground/60 mb-5">Contact</p>
          <div className="flex flex-col gap-3 text-sm">
            <a href="tel:9356070802" className="flex items-center gap-3 hover:text-accent transition-colors"><Phone size={18} weight="light" /> +91 93560 70802</a>
            <a href="https://wa.me/919356070802" target="_blank" rel="noreferrer" className="flex items-center gap-3 hover:text-accent transition-colors" data-testid="footer-whatsapp"><WhatsappLogo size={18} weight="light" /> WhatsApp</a>
            <a href="mailto:info@uniform-co.com" className="flex items-center gap-3 hover:text-accent transition-colors break-all"><EnvelopeSimple size={18} weight="light" /> info@uniform-co.com</a>
            <span className="flex items-center gap-3"><MapPin size={18} weight="light" /> Dhayri, Pune</span>
          </div>
        </div>
      </div>
      <div className="pt-8 flex flex-col md:flex-row justify-between gap-3 text-xs text-foreground/50">
        <span>© {new Date().getFullYear()} Uniform Co. All rights reserved.</span>
        <span className="font-mono">Tailored in Pune · Made to last</span>
      </div>
    </div>
  </footer>
);

export default Footer;
